import React from 'react';

const NoReply = () => (
    <div className="NoReply spacer-inline">
        <input className="form-control spacer-margin5 sp-mx" type="checkbox" />
    </div>
);


NoReply.defaultProps = {};

export default NoReply;
